import React from "react";
import LotesMovAlmacenUI from "./LotesMovAlmacenUI";
import PageError from "../componentes/PageError";
import PageLoading from "../componentes/PageLoading";
import LotesMovAlmacenService from "../services/LotesMovAlmacenService";
import {notificarError} from "../componentes/Almacenes/AlmacenNotify";


class LotesMovAlmacen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isLoading: false,
            error: null,
            table: {
                pageSize: 50,
                sorted: false,
                filtered: false,
                isLoading: true,
                pages: -1,
            },
            filterParams: {},
        };
        this.lotesService = new LotesMovAlmacenService();
        this.onFilterLotes = this.onFilterLotes.bind(this);
        this.setTableState = this.setTableState.bind(this);
    }

    async onFilterLotes(state, instance) {
        this.setTableState({isLoading: true});
        const params = {
            page: state.page,
            pageSize: state.pageSize,
            sorted: state.sorted,
            filtered: state.filtered
        }
        this.setState({data: [], filterParams: params});
        let lotes = await this.lotesService.filtrarLotes(params)
        const lotesClean = lotes.lotes ? lotes.lotes.filter(x => x) : [];
        if (lotesClean) {
            this.setState({data: lotesClean})
            this.setTableState({pages: lotes.pages || 1})
        } else
            notificarError("No se ha podido filtrar los lotes")
        this.setTableState({isLoading: false});
    }

    setTableState(newTableState) {
        this.setState((localState, props) => {
            return {
                table: {
                    ...localState.table,
                    ...newTableState,
                }
            }
        })
    }

    render() {
        const {isLoading, error} = this.state;
        if (isLoading && this.state.data.length === 0) {
            return <PageLoading/>;
        }
        if (error) {
            return <PageError error={this.state.error}/>;
        }
        return (
            <div id="lotesMovAlmacenContainer">
                <LotesMovAlmacenUI
                    onFilterLotes={this.onFilterLotes}
                    tableInfo={this.state.table}
                    data={this.state.data}
                    history={this.props.history}
                />
            </div>
        );
    }
}

export default LotesMovAlmacen;

